import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

const TargetTempSection = (props) => {
	const register = props.register;
	const isEditMode = props.isEditMode;
	const watch = props.watch;
	const setValue = props.setValue;
	const data = props.data;

	const january = watch("january_temp", data.january_temp);
	const february = watch("february_temp", data.february_temp);
	const march = watch("march_temp", data.march_temp);
	const april = watch("april_temp", data.april_temp);
	const may = watch("may_temp", data.may_temp);
	const june = watch("june_temp", data.june_temp);
	const july = watch("july_temp", data.july_temp);
	const august = watch("august_temp", data.august_temp);
	const september = watch("september_temp", data.september_temp);
	const october = watch("october_temp", data.october_temp);
	const november = watch("november_temp", data.november_temp);
	const december = watch("december_temp", data.december_temp);

	const [errors, setErrors] = useState({});

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) =>
		setValue(inputName, evt.target.value);

	useEffect(() => {
		const errorEntries = Object.entries(props.errors);
		const tempErrorEntries = errorEntries.map((entry) => {
			if (entry[0].includes("temp")) return entry;
			else return "";
		});

		const filteredUnused = tempErrorEntries.filter((entry) => entry !== "");

		setErrors(filteredUnused);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>Temperature (&#8451;)</h5>
			{errors.length > 0 && (
				<span className="required">
					*All Temperature(&#8451;) fields required
				</span>
			)}
			<hr />
			<Row>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>January</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={january}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "january_temp")}
								name="january_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>February</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={february}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "february_temp")}
								name="february_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>March</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={march}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "march_temp")}
								name="march_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>April</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={april}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "april_temp")}
								name="april_temp"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>May</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={may}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "may_temp")}
								name="may_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>June</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={june}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "june_temp")}
								name="june_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>July</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={july}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "july_temp")}
								name="july_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>August</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={august}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "august_temp")}
								name="august_temp"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>September</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={september}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "september_temp")}
								name="september_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>October</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={october}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "october_temp")}
								name="october_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>November</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={november}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "november_temp")}
								name="november_temp"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>December</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={december}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "december_temp")}
								name="december_temp"
							></input>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default TargetTempSection;
